/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import moment, {Moment} from "moment";

export const MOMENT_FORMATS: string[] = [
    'MM/DD/YYYY HH:mm:ss',
    'MM-DD-YYYY HH:mm:ss',
    'DD/MM/YYYY HH:mm:ss',
    'DD-MM-YYYY HH:mm:ss',
    'YYYY-MM-DD HH:mm:ss',
    'YYYY/MM/DD HH:mm:ss',
    'DD/MM/YYYYTHH:mm:ss',
    'DD-MM-YYYYTHH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss',
    'MM/DD/YYYY HH:mm',
    'MM-DD-YYYY HH:mm',
    'DD/MM/YYYY HH:mm',
    'DD-MM-YYYY HH:mm',
    'YYYY-MM-DD HH:mm',
    'YYYY/MM/DD HH:mm',
    'DD/MM/YYYYTHH:mm',
    'DD-MM-YYYYTHH:mm',
    'YYYY-MM-DDTHH:mm',
    'YYYY/MM/DDTHH:mm',
    'YYYY-MM-DD',
    'YYYY/MM/DD',
    'MM-DD-YYYY',
    'MM/DD/YYYY',
    'DD-MM-YYYY',
    'DD/MM/YYYY',
];

export const toMoment = (dateValue?: string | Moment | null | Date, formats: string[] | string = MOMENT_FORMATS): Moment => {
    if (moment.isMoment(dateValue)) return dateValue;
    if(dateValue instanceof Date) return moment(dateValue);
    if (!dateValue || !dateValue.length) return moment();
    return moment(dateValue, formats);
};

export const formatMoment = (date?: Moment, format: string = 'YYYY-MM-DDTHH:mm:ss'): string => {
    if (!date) date = toMoment();
    return date.format(format);
};